import { AxiosRequestConfig } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import GetPaginatedResponse from '../Responses/PaginatedResponse';

import CustomRedirect from 'Api/Models/CustomRedirect';

class CustomRedirectsApi extends AbstractCRMApi {
    public endpoint: string = 'custom-redirects';

    public async getById(id: number): Promise<CustomRedirect> {
        const response = await this.get(`/${id}`);
        return CustomRedirectsApi.mapDataToCustomRedirectClass(response.data);
    }

    public async getCustomRedirects(
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<CustomRedirect>> {
        const response = await this.get('', {
            ...config,
            params: { ...config?.params, page },
        });

        return AbstractCRMApi.mapPaginatedDataToModel(response.data, CustomRedirect);
    }

    public async store(customRedirect: CustomRedirect): Promise<CustomRedirect> {
        const response = await this.post('', customRedirect);
        return CustomRedirectsApi.mapDataToCustomRedirectClass(response.data);
    }

    public async update(customRedirect: CustomRedirect): Promise<CustomRedirect> {
        const response = await this.patch(`/${customRedirect.id}`, customRedirect);
        return CustomRedirectsApi.mapDataToCustomRedirectClass(response.data);
    }
}

export default new CustomRedirectsApi();
